import React from 'react';
import styles from './FormField.module.css';

export interface FormFieldProps {
  label?: string;
  htmlFor?: string;
  error?: string | boolean;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'booking';
  'data-test'?: string;
}

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  'data-test'?: string;
}

export function FormField({ label, htmlFor, error, icon, children, className = '', variant, ...rest }: FormFieldProps) {
  const wrapperCn = [
    styles.wrapper,
    error ? styles.error : '',
    icon ? styles.hasIconLeft : '',
    variant === 'booking' ? styles.booking : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={wrapperCn} {...rest}>
      {label && <label className={styles.label} htmlFor={htmlFor}>{label}</label>}
      <div className={styles.inputArea}>
        {children}
        {icon && <span className={styles.icon}>{icon}</span>}
      </div>
      {typeof error === 'string' && error && (
        <span className={styles.errorMessage}>{error}</span>
      )}
    </div>
  );
}

export function Input({ className = '', ...rest }: InputProps) {
  return <input className={`${styles.input} ${className}`.trim()} {...rest} />;
}
